
export const IDENTITY_CONFIG = (props) => {

    return {
        authority: props.appSettings.FLAGSTONE_IDP_BASE_URL, //(string): The URL of the OIDC provider.
        client_id: props.appSettings.FLAGSTONE_IDP_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
        redirect_uri: props.appSettings.REACT_APP_REDIRECT_URL, //The URI of your client application to receive a response from the OIDC provider.
        login: `${props.appSettings.FLAGSTONE_IDP_BASE_URL}/login`,
        automaticSilentRenew: false, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
        loadUserInfo: true, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
        silent_redirect_uri: props.appSettings.REACT_APP_SILENT_REDIRECT_URL, //(string): The URL for the page containing the code handling the silent renew.
        post_logout_redirect_uri: props.appSettings.REACT_APP_LOGOUT_REDIRECT_URL, // (string): The OIDC post-logout redirect URI.
        audience: props.appSettings.IPB_SHOPFLOOR_API_BASE_URL, //is there a way to specific the audience when making the jwt
        response_type: "id_token token", //(string, default: 'id_token'): The type of response desired from the OIDC provider.
        grantType: "password",
        scope: "openid profile email roles shopfloor_api interfacing_api", //(string, default: 'openid'): The scope being requested from the OIDC provider.
    }

    //filterProtocolClaims: false,
    //webAuthResponseType: "id_token token"
};

export const METADATA_OIDC = (props) => {
    return {
        issuer: props.appSettings.FLAGSTONE_IDP_BASE_URL,
        jwks_uri: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/.well-known/openid-configuration/jwks",
        authorization_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/authorize",
        token_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/token",
        userinfo_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/userinfo",
        end_session_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/endsession",
        check_session_iframe: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/checksession",
        revocation_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/revocation",
        introspection_endpoint: props.appSettings.FLAGSTONE_IDP_BASE_URL + "/connect/introspect"
    }
};

export const roles = { 'PLOEGCHEF': 'Ploegchef', 'OPERATOR': 'Operator', 'ADMINISTRATOR': 'Administrator' }
